import React from 'react';
import ReactDOM from "react-dom/client";
import "./index.css";
import PrivateRoute from './PrivateRoute.jsx';
import Core from './Corepage.jsx';
import Task from './comps/task.jsx';
import NotFoundPage from './comps/notFound.jsx';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Landing from './comps/landing.jsx';
import LoginForm from './comps/Login.jsx';
import Otpverify from './comps/Otpverify.jsx';
import Power from './Power.jsx';
import Play from './Playbook.jsx';
import Chooseplay from './comps/Chooseplay.jsx';
import Playbook1 from './comps/Playbook1.jsx';



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Landing} />
      <Route path="/login" exact component={LoginForm} />
      <Route path="/Otpverify" exact component={Otpverify} />
      <PrivateRoute path="/task" component={Task} /> 
      {/* <PrivateRoute path="/Playbook1" component={Play} />  */}
      <PrivateRoute path="/Playbook" component={Play} />
      <PrivateRoute path="/Chooseplay" component={Chooseplay} />
      <PrivateRoute path="/coredataegap" component={Core} />
      <PrivateRoute path="/power" component={Power} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  </BrowserRouter>
  // </React.StrictMode>
);
